import { httpClient } from '../utils/http.client';
import { API_ENDPOINTS } from '../config/api.config';

export const notificationService = {
  // Get all notifications with pagination
  getNotifications: async (params = {}) => {
    return await httpClient.get(API_ENDPOINTS.NOTIFICATIONS.LIST, { params });
  },

  // Get notification by ID
  getNotificationById: async (notificationId) => {
    return await httpClient.get(`${API_ENDPOINTS.NOTIFICATIONS.DETAIL}/${notificationId}`);
  },

  // Create new notification
  createNotification: async (notificationData) => {
    return await httpClient.post(API_ENDPOINTS.NOTIFICATIONS.CREATE, notificationData);
  },

  // Update notification
  updateNotification: async (notificationId, notificationData) => {
    return await httpClient.put(
      `${API_ENDPOINTS.NOTIFICATIONS.UPDATE}/${notificationId}`,
      notificationData
    );
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    return await httpClient.delete(`${API_ENDPOINTS.NOTIFICATIONS.DELETE}/${notificationId}`);
  },

  // Get notification types
  getNotificationTypes: async () => {
    return await httpClient.get(API_ENDPOINTS.NOTIFICATIONS.TYPES);
  },

  // Get active notifications by role
  getActiveNotificationsByRole: async (roleId) => {
    return await httpClient.get(API_ENDPOINTS.NOTIFICATIONS.ACTIVE_BY_ROLE(roleId));
  },

  // Deactivate notification
  deactivateNotification: async (notificationId) => {
    return await httpClient.post(API_ENDPOINTS.NOTIFICATIONS.DEACTIVATE(notificationId));
  },

  // Activate notification
  activateNotification: async (notificationId) => {
    return await httpClient.post(API_ENDPOINTS.NOTIFICATIONS.ACTIVATE(notificationId));
  },

  // Upload document temporarily (before notification creation)
  uploadDocumentTemp: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    return await httpClient.post(
      API_ENDPOINTS.NOTIFICATIONS.UPLOAD_DOCUMENT_TEMP,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  },

  // Get notification action types for audit filtering
  getNotificationActionTypes: async () => {
    return await httpClient.get(API_ENDPOINTS.NOTIFICATIONS.ACTION_TYPES);
  },
};
